import React, { useState } from 'react';
import { ArrowUp, ArrowDown, Pencil, Check, X, Lock } from 'lucide-react';

const inputCls = 'bg-black border-2 border-zinc-700 focus:border-orange-500 outline-none px-2 py-1 text-xs text-white';

export const ScopeCell = ({ item, locked, canUp, canDown, onMove, onSave, testid }) => {
  const [edit, setEdit] = useState(false);
  const [f, setF] = useState({ code: item.code, focus: item.focus });

  if (edit) {
    return (
      <div className="flex flex-col gap-1.5 min-w-[180px]" data-testid={`${testid}-edit`}>
        <input className={inputCls} value={f.code} onChange={(e) => setF({ ...f, code: e.target.value })} placeholder="Standard code" data-testid={`${testid}-code`} />
        <input className={inputCls} value={f.focus} onChange={(e) => setF({ ...f, focus: e.target.value })} placeholder="Focus" data-testid={`${testid}-focus`} />
        <div className="flex gap-1">
          <button onClick={async () => { if (await onSave(f)) setEdit(false); }} className="p-1 text-emerald-400 hover:text-emerald-300" data-testid={`${testid}-save`}><Check className="w-4 h-4" /></button>
          <button onClick={() => { setF({ code: item.code, focus: item.focus }); setEdit(false); }} className="p-1 text-zinc-500 hover:text-white" data-testid={`${testid}-cancel`}><X className="w-4 h-4" /></button>
        </div>
      </div>
    );
  }
  return (
    <div className="group flex items-start gap-2 min-w-[180px]" data-testid={testid}>
      <div className="flex-1"><b className="text-orange-400">{item.code}</b> <span className="text-zinc-300">{item.focus}</span></div>
      {locked ? <Lock className="w-3 h-3 text-zinc-700 shrink-0 mt-0.5" /> : (
        <div className="flex flex-col opacity-40 group-hover:opacity-100 transition-opacity shrink-0">
          <button onClick={() => setEdit(true)} className="p-0.5 text-zinc-400 hover:text-orange-400" title="Edit" data-testid={`${testid}-edit-btn`}><Pencil className="w-3 h-3" /></button>
          {canUp && <button onClick={() => onMove(-1)} className="p-0.5 text-zinc-400 hover:text-white" title="Move earlier" data-testid={`${testid}-up`}><ArrowUp className="w-3 h-3" /></button>}
          {canDown && <button onClick={() => onMove(1)} className="p-0.5 text-zinc-400 hover:text-white" title="Move later" data-testid={`${testid}-down`}><ArrowDown className="w-3 h-3" /></button>}
        </div>
      )}
    </div>
  );
};
